import React from "react"
import PropTypes from "prop-types"
import gridStyles from "../../utils/gridStyles"

const FormGrid = ({ children }) => (
  <div className={gridStyles("container-fluid")}>{children}</div>
)

FormGrid.propTypes = {
  children: PropTypes.node,
}

export default FormGrid
